import React, { FC } from 'react';
import ReactLoading from 'react-loading';

import './styles.scss';

type Props = {
  color?: string;
  height?: number;
  width?: number;
  type?: string;
  className?: string;
};

const Loader: FC<Props> = (props: Props) => {
  const { color, height, width, type } = props;
  return (
    <ReactLoading
      // @ts-ignore
      type={type || 'spin'}
      color={color || '#ffffff'}
      className={`loader ${props.className || ''}`}
      width={width}
      height={height}
    />
  );
};

export default Loader;
